import { Injectable } from '@angular/core';
import { TimerFormats } from '../models/timer-formats.model';

@Injectable()
export class TimerFormatsService {
	timerFormats: Array<TimerFormats>;

	constructor() {}

	getTimerFormats(): Array<TimerFormats> {
		return (this.timerFormats = [
			new TimerFormats({ id: 0, value: '%D', label: 'Two digits DAYS', groupId: 0 }),
			new TimerFormats({ id: 1, value: '%d', label: 'One digit DAYS', groupId: 0 }),
			new TimerFormats({ id: 2, value: '%A', label: 'Total HOURS (inc days)', groupId: 1 }),
			new TimerFormats({ id: 3, value: '%H', label: 'Two digits HOURS', groupId: 1 }),
			new TimerFormats({ id: 4, value: '%h', label: 'One digit HOURS', groupId: 1 }),
			new TimerFormats({ id: 5, value: '%I', label: 'Two digits MINUTES', groupId: 2 }),
			new TimerFormats({ id: 6, value: '%i', label: 'One digit MINUTES', groupId: 2 }),
			new TimerFormats({ id: 7, value: '%S', label: 'Two digits SECONDS', groupId: 3 }),
			new TimerFormats({ id: 8, value: '%s', label: 'One digit SECONDS', groupId: 3 })
		]);
	}
}
